module.exports = __webpack_public_path__ + "static/media/LawrenceHoldingBees.37910a3e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/LawrenceHoldingBees.jpg
// module id = 251
// module chunks = 0